export enum Method {
  POST = "POST",
  GET = "GET",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export enum Screen {
  PENDING = "pending",
  INFORMATION = "information",
  SOURCE_SELECTION = "source-selection",
  DATA_SELECTION = "data-selection",
  CREDENTIALS = "credentials",
  PROOF_GENERATION = "proof-generation",
  PROOF_COMPLETION = "proof-completion",
  ERROR = "error",
  OAUTH = "oauth",
  TIMEOUT = "timeout",
  USER_NETWORK = "user-network",
}

export enum SocketActionTypes {
  REQUEST_PROMPT = "request_prompt",
  SCRIPT_LOG = "script_log",
  REQUEST_OAUTH = "request_oauth",
  DONE = "script_done",
  CLOSE = "close",
  ERROR = "error",
  METADATA = "metadata",
  FINISHED = "finished",
  TIMEOUT = "timeout",
  REQUEST_USER_NETWORK = "request_user_network",
  REQUEST_USER_NETWORK_DONE = "request_user_network_done",
  CDP_TARGET = "cdp_target",
}
